/**
 * @module settings ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { companyActions } from '~/behaviors/actions/company.actions';

const defaultState = {
  isLoadingKioskConfig: false,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const settingsUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);

  builder.addCase(companyActions.fetchCompanyKioskSettings.pending, merge({ isLoadingKioskConfig: true }));
  builder.addCase(companyActions.fetchCompanyKioskSettings.fulfilled, merge({ isLoadingKioskConfig: false }));
  builder.addCase(companyActions.fetchCompanyKioskSettings.rejected, merge({ isLoadingKioskConfig: false }));
});

export default settingsUI;
